import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { ButtonComponent, DatalayerService, MaybeExternalLinkDirective } from '@woolworthsnz/styleguide';
import { TargetTranslatePipe } from '../../pipes/target-translate.pipe';
@Component({
	selector: 'dc-image-navigation',
	template: `
		<a
			cdxButton
			[href]="link === '' ? null : link"
			[target]="linkTarget | toTarget"
			maybeExternal
			fillStyle="secondaryFlat"
			(click)="handleClick(text)"
			[title]="text"
		>
			<img [src]="image" [alt]="imageAlt" />
			<span>{{ text }}</span>
		</a>
	`,
	styleUrls: ['./image-navigation.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
	imports: [MaybeExternalLinkDirective, ButtonComponent, TargetTranslatePipe],
})
export class ImageNavigationComponent {
	@Input()
	link: string;

	@Input()
	linkTarget: 'self' | 'newwindow' = 'self';

	@Input()
	image: string;

	@Input()
	imageAlt: string;

	@Input()
	text: string;

	constructor(private datalayerService: DatalayerService) {}

	handleClick = (text: string): void => {
		this.datalayerService.trackImageNavigationItemEvent(text);
	};
}
